module.exports = __webpack_public_path__ + "countries-6213c40e8f13003dd4e7520187c81b2b.json";


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/utils/json/countries.json
 ** module id = 285
 ** module chunks = 0
 **/